'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _search = require('./search');

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxAsyncConnect.reducer, // ,
  search: _search.searchReducer,
  shareClass: _search.shareClassReducer,
  familyShareClass: _search.familyShareClassReducer,
  tutorialdismiss: _search.tutorialdismissReducer,
  company: _search.companyReducer,
  compare: _search.compareReducer,
  cart: _search.cartReducer,
  fundsByStrategy: _search.fundsByStrategyReducer
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 1401
// module chunks = 0